export const SET_USAGE_REPORT = 'reports@SET_USAGE_REPORT';
export const FIND_USAGE_REPORT = 'reports@FIND_USAGE_REPORT';

export const setUsageReport = (report) => { return { type: SET_USAGE_REPORT, data: report } }
export const findUsageReport = () => ({ type: FIND_USAGE_REPORT })